
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pvc/windows",
      function () {
        return require("private-next-pages/pvc/windows/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pvc/windows"])
      });
    }
  